package ru.villawonka.app.presentation.screens.favorites.viewmodel

import ru.villawonka.app.common.mvvm.BaseViewModel
import ru.villawonka.app.common.utils.fold
import ru.villawonka.app.domain.service.FavoritesService
import ru.villawonka.app.presentation.model.PostUIModel
import ru.villawonka.app.presentation.model.toUIModel

class FavoritesViewModel(
    private val favoritesService: FavoritesService,
) : BaseViewModel<FavoritesUIState>() {

    init {
        loadScreen(true)
        observeToggleLikeEvents()
        observeFavoritePosts()
    }

    override fun createInitialState() = FavoritesUIState.Loading

    fun onGoToSearchButtonClick() = launch { shootEvent(FavoritesUIEvent.OpenSearch) }

    fun onRetryButtonClick() = launch { loadScreen(true) }

    private fun loadScreen(withProgress: Boolean) = launch {
        if (withProgress) setState(FavoritesUIState.Loading)
        favoritesService.remoteSync()
    }

    private fun observeFavoritePosts() = launch {
        favoritesService.favoritePosts.collect { result ->
            val state = result.fold(
                ifLeft = { failure -> FavoritesUIState.Error(failure) },
                ifRight = { posts ->
                    if (posts.isEmpty()) {
                        FavoritesUIState.Empty
                    } else {
                        FavoritesUIState.Data(posts.map { it.toUIModel() })
                    }
                }
            )
            setState(state)
        }
    }

    private fun observeToggleLikeEvents() = launch {
        favoritesService.toggleLikeEvents.collect { (postId, isLiked) ->
            currentStateValue.asData()?.let { state ->
                setState(state.copy(
                    posts = state.posts.map { currentPost ->
                        if (currentPost.id == postId) {
                            when (currentPost) {
                                is PostUIModel.Accommodation -> {
                                    currentPost.copy(isLiked = isLiked)
                                }
                            }
                        } else {
                            currentPost
                        }
                    }
                ))
            }
        }
    }
}